import React from 'react';
import styles from './styles.module.scss';

interface Props {
  loading?: boolean;
  moreText?: boolean;
  hasMore?: boolean;
  noMoreText?: boolean;
}

function DataListFooter(props: Props) {
  let content = null;

  if (props.loading) {
    content = <div className={styles.text}>正在加载...</div>;
  } else {
    let text = props.moreText;

    if (props.hasMore === false) {
      text = props.noMoreText;
    }

    content = <div className={styles.text}>{text}</div>;
  }

  return <div className={styles.container}>{content}</div>;
}

DataListFooter.defaultProps = {
  noMoreText: '- 已经到底了 -',
  moreText: '上拉加载更多',
  loading: false,
  hasMore: false,
};

export default React.memo(DataListFooter);
